module.exports = __webpack_public_path__ + "img/back-icon00.6043450f.png";